<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Add a Network</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">
                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Name
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="text" id="city" placeholder="ABC" v-model="data.name">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Market Type
                    </label>
                    <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="data.marketType">
                            <option value="national">National</option>
                            <option value="local">Local</option>
                        </select>
                    </label>
                </div>

                <div class="mb-4" v-if="data.marketType == 'local'">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Location
                    </label>
                    <label class="dropdown_wrap">
                        <v-select :debounce="250" @search="getOptions" :options="locationCollection" v-model="data.location" placeholder="Search for a location..." label="text"></v-select>
                    </label>
                </div>
            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <!-- @click="addAnnouncement()" -->
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="editNetwork" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Edit Network
                </button>
            </div>

        </div>
    </Modal>
</template>

<script>
    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';

    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                displayModal: false,
                data: {
                    id: null,
                    name: null,
                    marketType: 'national',
                    location: null,
                },
                locationCollection: null,
            }
        },
        
        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-edit-network-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('admin-edit-network-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),
            close() {
                // this.active = false;
            },

            open(data) {
                this.displayModal = true
                this.data = data
                this.data.location = data.locationText
            },

            editNetwork() {
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/networks/" + this.data.id + "/edit", this.data, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.status)
                    if(response.status == 200) {
                        _this.displayModal = false
                    }
                });
            },

            getOptions(search, loading) {
                loading(true)
                this.$http.get('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&countryCode=USA%2CPRI%2CVIR%2CGUM%2CASM&category=Postal%2CPopulated+Place&maxSuggestions=10&text=' + search)
                    .then(resp => {
                        this.locationCollection = resp.data.suggestions
                        loading(false)
                    })
            },

        }
        
    }
</script>
